import { createSelector } from 'reselect'

import interactiveVideoSelectors from 'redux/selectors/interactive_videos'

const getInteractiveVideoSession = state => state.interactiveVideo
const identitySelector = interactiveVideoSelectors.interactiveVideoIdentitySelector

export default createSelector(
	[
		getInteractiveVideoSession,
		identitySelector,
	],
	(interactiveVideo, interactiveVideoIdentity) => ({
		jwt: interactiveVideoIdentity.jwt,
		uid: interactiveVideoIdentity.uid,
		participantUid: interactiveVideo.participantUid,
		role: interactiveVideo.role,
		sessionType: interactiveVideo.sessionType,
	})
)
